/* Mobile navigation */
(function () {
    'use strict';

    var toggle = document.querySelector('[data-menu-toggle]');
    if (!toggle) {
        return;
    }

    function setOpen(open) {
        document.body.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', String(open));
    }

    toggle.addEventListener('click', function () {
        setOpen(!document.body.classList.contains('is-menu-open'));
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('is-menu-open')) {
            setOpen(false);
            toggle.focus();
        }
    });

    window.matchMedia('(min-width: 961px)').addEventListener('change', function (mq) {
        if (mq.matches) {
            setOpen(false);
        }
    });
})();
